import { Box } from '@mui/material';

import Text from 'components/Text';
import { useUser } from 'global/UserContext';
import DashboardsCommunityProfile from 'microfrontends/Dashboards/CommunityProfile';
import { MenuItem } from 'types/menuTypes';

interface CommunityProfileProps {
  formId?: string;
  formName?: string;
  menu: MenuItem;
}

export const CommunityProfile = ({ formId, formName, menu }: CommunityProfileProps) => {
  const { user } = useUser();
  const userId = user?.id;

  console.log('[CommunityProfile] formId', formId, 'formName', formName, 'menu', menu);

  if (!formId || !formName) {
    return (
      <Box>
        <Text color="textSecondary" textAlign="center">
          Nenhum formulário encontrado para esta página.
        </Text>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '200vh',
        overflow: 'hidden',
        flex: 1,
        minHeight: 0,
      }}
    >
      <DashboardsCommunityProfile
        key={formId}
        pageName={formName}
        formId={formId}
        userId={userId || ''}
      />
    </Box>
  );
};
